<app-recent-orders *ngIf="isLoggedIn()"></app-recent-orders>
<!-- Main image of the home page -->
<div class="homePrimary">
  <!-- This is the error area which should almost never be used -->
  <app-alert [alertService]="alertService" [parentComponent]="this"></app-alert>

  <!-- This is the main and tablet images with any button for the user to be clicked -->
  <div class="imageWrapDiv">
    <span class="col-lg-12 col-md-12 col-sm-12 col-xs-12 loading-animation align-center" [@fade]="!imagesLoaded ? 'shown' : 'hidden'">&nbsp;</span>

    <!-- This section displays the primar images (desktop and mobile version) along with the button if provided and tiles -->
    <div *ngIf="loaded" [@fade]="imagesLoaded ? 'shown' : 'hidden'">
      <ul>
        <li *ngFor="let feature of homeList" class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 innerImgWrap">
            <img alt="Home page content image" appLazyLoad (load)="showTiles(feature)" class="primaryImg" src="{{imageUrlSvr}}/{{feature.homePageContent[0].imageUrl}}" alt="{{feature.homePageContent[0].altText}}"/>
            <img alt="Home page content image" appLazyLoad class="primaryTabletImg" [style.display]="{'none': isMobileWidth}" src="{{imageUrlSvr}}/{{feature.homePageContent[0].mobileImageUrl}}" alt="{{feature.homePageContent[0].altText}}"/>
            <div class="buttonDiv">
              <a *ngIf="feature.homePageAdditionalContents[0].openUrlIn === 'Current' || !feature.homePageAdditionalContents[0].openUrlIn"
                [routerLink]="['/' + feature.homePageAdditionalContents[0].buttonAction]"
                class="messageBtn"
                [ngClass]="feature.homePageAdditionalContents[0].buttonLoc.trim().toLowerCase()"
                [ngStyle]="{
                  'margin-right': feature.homePageAdditionalContents[0].buttonLoc.trim().toLowerCase() == 'right' ? (feature.homePageAdditionalContents[0].offsetX / 20) + '%': '0',
                  'margin-left': feature.homePageAdditionalContents[0].buttonLoc.trim().toLowerCase() == 'left' ? (feature.homePageAdditionalContents[0].offsetX / 20) + '%': '0'
                }"
                [style.marginTop]="(feature.homePageAdditionalContents[0].offsetY/20) + '%'"
              >
                {{feature.homePageAdditionalContents[0].buttonText}}
              </a>
              <a *ngIf="feature.homePageAdditionalContents[0].openUrlIn === 'New'"
              [href]="[feature.homePageAdditionalContents[0].buttonAction]"
              class="messageBtn"
              [ngClass]="feature.homePageAdditionalContents[0].buttonLoc.trim().toLowerCase()"
              [ngStyle]="{
                'margin-right': feature.homePageAdditionalContents[0].buttonLoc.trim().toLowerCase() == 'right' ? (feature.homePageAdditionalContents[0].offsetX / 20) + '%': '0',
                'margin-left': feature.homePageAdditionalContents[0].buttonLoc.trim().toLowerCase() == 'left' ? (feature.homePageAdditionalContents[0].offsetX / 20) + '%': '0'
              }"
              [style.marginTop]="(feature.homePageAdditionalContents[0].offsetY/20) + '%'"
            >
              {{feature.homePageAdditionalContents[0].buttonText}}
            </a>
            </div>

            <!-- This is the menu tiles that are overlayed on top of the home page image.
            Normally an ngIf statement is not needed here, but since the variable response is loaded after a setTimeout
            call, we need to set a flag around the loading of that variable from the httpGet call. The reason for the
            setTimeout is because the location API call to the browser for getPositon is loaded after the DOM loads on most
            browsers. So a settimeout stops blocking and causes the httpGet call to go after the location code finishes. -->
            <div *ngIf="feature.show" class="tilesRowDiv hidden-sm hidden-xs">
              <div *ngFor="let secondary of feature.primaryFeatureImageItem | orderArrayObjBy: 'sort' : false" class="col-md-2 col-lg-2">
                <!-- Check if categoryID has been set. If so then create the tile and link for that. If not, then check for
                  the recipeId. If that is set then create that tile and link instead. If neither are set, then create no tile -->
                <ng-container *ngIf="secondary.isViewMore; else checkRecTemplate">
                  <a [routerLink]="['/menu']" routerLinkActive="active">
                    <img alt="Home page content image" src="{{imageUrlSvr}}/{{secondary.url}}" alt="{{secondary?.altText}}" class="pointer tileImg"/>
                  </a>
                </ng-container>
                <ng-template #checkRecTemplate>
                  <ng-container *ngIf="secondary.recipeId && secondary.categoryId; else checkCatTemplate">
                    <a *ngIf="secondary.recipeId" [routerLink]="['/categories/' + secondary.categoryId + '/recipes/' + secondary.name + '-' + secondary.recipeId + '/customization/1']" routerLinkActive="active">
                      <img alt="Home page content image" src="{{imageUrlSvr}}/{{secondary.url}}" alt="{{secondary?.altText}}" class="pointer tileImg"/>
                    </a>
                  </ng-container>
                </ng-template>
                <ng-template #checkCatTemplate>
                  <a [routerLink]="['/menu/categories/',  secondary.name + '-' + secondary.categoryId]" routerLinkActive="active">
                    <img alt="Home page content image" src="{{imageUrlSvr}}/{{secondary.url}}" alt="{{secondary?.altText}}" class="pointer tileImg"/>
                  </a>
                </ng-template>
              </div>
            </div>
          </div>

          <div class="tilesColsDiv hidden-lg hidden-md">
              <div *ngFor="let secondary of feature.primaryFeatureImageItem | orderArrayObjBy: 'sort' : false" class="col-sm-6 col-xs-6">
                <!-- Check if categoryID has been set. If so then create the tile and link for that. If not, then check for
                  the recipeId. If that is set then create that tile and link instead. If neither are set, then create no tile -->
                  <ng-container *ngIf="secondary.isViewMore; else checkRecTemplate">
                    <a [routerLink]="['/menu']" routerLinkActive="active">
                      <img alt="Home page content image" appLazyLoad src="{{imageUrlSvr}}/{{secondary.url}}" alt="{{secondary?.altText}}" class="pointer tileImg"/>
                    </a>
                  </ng-container>
                  <ng-template #checkRecTemplate>
                    <ng-container *ngIf="secondary.recipeId && secondary.categoryId; else checkCatTemplate">
                      <a [routerLink]="['/categories/' +  secondary.categoryId + '/recipes/' +  secondary.name + '-'  + secondary.recipeId + '/customization/1']" routerLinkActive="active">
                        <img alt="Home page content image" appLazyLoad src="{{imageUrlSvr}}/{{secondary.url}}" alt="{{secondary?.altText}}" class="pointer tileImg"/>
                      </a>
                    </ng-container>
                  </ng-template>
                  <ng-template #checkCatTemplate>
                    <a [routerLink]="['/menu/categories/' + secondary.categoryId]" routerLinkActive="active">
                      <img alt="Home page content image" appLazyLoad src="{{imageUrlSvr}}/{{secondary.url}}" alt="{{secondary?.altText}}" class="pointer tileImg"/>
                    </a>
                  </ng-template>
              </div>
          </div>

          <div class="ViewAllMenuDiv hidden-lg hidden-md col-sm-12 col-xs-12">
            <a [routerLink]="['/menu/']" routerLinkActive="active" aria-label="View Full Menu">
              View full menu
              <span class="right-chevron"></span>
            </a>
          </div>
        </li>
      </ul>
    </div>
  </div>
</div>

<!-- This is used to trigger the animation of the above section after all images have loaded. -->
<div *ngIf="loaded" style="display: none"><img alt="Home page content image" src="{{imageUrlSvr}}/{{homeList[0].homePageContent[0].imageUrl}}" (load)="finishedLoading();"/></div>

<!-- this is like the sub footer of the home page -->
<div class="homeActions text-center row" style="margin-top: 20px;">
  <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
    <div class="iconDiv">
      <img alt="stories icon" appLazyLoad src="../../../assets/images/home/stories_icon.png" class="homeIcon">
    </div>
    <div>
      <h3>Stories</h3>
      <h5>See what's cooking at Whataburger&reg;,
        <br/>including the latest stories, news, and events.</h5>
    </div>
    <div>
      <!-- This <a> tag will need to be a div tag with a routerLink attribute when the page it links to is
      part of the angular website. Same goes for other <a> tags on this page that still link to the old site-->
      <a href="http://stories.whataburger.com" class="link">
        <span class="linkSpan">See more</span>
      </a>
    </div>
  </div>
  <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
    <div class="iconDiv">
      <img alt="careers icon" appLazyLoad src="../../../assets/images/home/careers_icon.png" class="homeIcon">
    </div>
    <div>
      <h3>Careers</h3>
      <h5>Discover opportunities at the restaurants,
        <br/>home office, and in the field.</h5>
    </div>
    <div>
      <a [routerLink]="['/careers']" class="link">
        <span class="linkSpan">View openings</span>
      </a>
    </div>
  </div>
  <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
    <div class="iconDiv">
      <img alt="whatastore icon" appLazyLoad src="../../../assets/images/home/whatastore_icon.png" class="homeIcon">
    </div>
    <div>
      <h3>Whatastore&#174;</h3>
      <h5>Show your good taste in apparel, gifts,
        <br/>groceries, and more.</h5>
    </div>
    <a href="https://shop.whataburger.com/" class="link">
      <span class="linkSpan">Shop Now</span></a>
  </div>
</div>
